import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import { AlertSettingsFilterPanelComponent } from "../alert-settings-filter-panel/alert-settings-filter-panel.component";
import { AlertSettingsGridWrapperComponent } from "../alert-settings-grid-wrapper/alert-settings-grid-wrapper.component";
import { AlertSettingsPageDataService } from "../alert-settings-page-data.service";
import { AppService } from "src/app/app.service";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "app-alert-settings-page",
  templateUrl: "./alert-settings-page.component.html",
  styleUrls: ["./alert-settings-page.component.scss"],
  host: { class: "alert-settings-page" },
  encapsulation: ViewEncapsulation.None,
})
export class AlertSettingsPageComponent implements OnInit {
  alertCompanyData: Array<Dictionary<any>>;
  selectedRows: Array<any>;
  selectedTab: string;
  selectedCompany: Array<string>;
  @ViewChild(AlertSettingsGridWrapperComponent)
  alertGridComp: AlertSettingsGridWrapperComponent;

  @ViewChild(AlertSettingsFilterPanelComponent)
  filterPanelComp: AlertSettingsFilterPanelComponent;
  constructor(
    private dataService: AlertSettingsPageDataService,
    private message: NzMessageService,
    private appService: AppService,
  ) {
    this.alertCompanyData = [];
    this.selectedRows = [];
  }
  ngOnInit() {
    //company data to be used for internal serach
    this.alertCompanyData = [];
    this.selectedRows = [];
    this.selectedTab = "company";
    this.appService.logUserAction(
      {},
      "",
      "",
      "ALERT_SETTINGS_PAGE",
      "",
      "",
      "ALERT_SETTINGS_CLICK",
    );
  }
  selectedRowsChange(event) {
    this.selectedRows = this.selectedTab === "company" ? event : event[0];
  }
  alertCompanyDataSet(event) {
    this.alertCompanyData = event;
    this.filterPanelComp.setSelectedCompany(null);
  }
  onAlertTypeChange(event) {
    this.selectedTab = event;
  }
  selectCompany(event) {
    this.selectedCompany = event;
  }
  getTabParams() {
    const isCompanyTab = this.selectedTab === "company";
    const feature = isCompanyTab
      ? "USER_ALERT_DELETE"
      : "WATCHLIST_ALERT_DELETE";
    const actionSource = isCompanyTab
      ? "DELETE USER ALERT"
      : "DELETE WATCHLIST ALERT";
    return {
      feature,
      actionSource,
    };
  }

  deleteAlerts(data?) {
    const { feature, actionSource } = this.getTabParams();
    let alertIds = [];
    if (data) alertIds = [data];
    else alertIds = this.selectedRows.map((val) => val.id);
    this.appService.logUserAction(
      {},
      "",
      "",
      feature,
      { alert_id: alertIds, action: "SOFT_DELETE" },
      "",
      actionSource,
    );

    this.dataService.deleteAlert(alertIds).subscribe(() => {
      //delete selectedRows from grid
      this.message.create("success", `Alert successfully deleted.`);
      this.alertGridComp.reloadGrid();
      this.filterPanelComp.setSelectedCompany(null);
    });
  }
  addAlert() {
    this.alertGridComp.reloadGrid();
  }
}
